import {Injectable} from '@angular/core';

@Injectable()
export class LoggerService {

  constructor() {}

  error(msg: string) {
    console.error(msg);
  }
}
